export default __webpack_public_path__ + "static/media/chico_chica_movil.08dd0913.svg";